import { CardIssueStatus, CardIssueType } from "./Enums";


export class CardModel {

    public constructor(init?: Partial<CardModel>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            Object.assign(this, init);
        }
    }

    token: string;

    name: string;
    description: string;

    owner: string;
    brand: string;
    masked: string;
    expiration: string;

    isCurrent: boolean;

    createdAt: Date;
}


export class CustomerCardModel {

    public constructor(init?: Partial<Pick<CustomerCardModel, keyof CustomerCardModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.deletedAt === 'string') {
                init.deletedAt = new Date(init.deletedAt);
            }
            Object.assign(this, init);
        }
    }

    token: string;

    name: string;

    customerId: number;

    brand: string;

    masked: string;

    owner: string;

    isCurrent: boolean;

    createdAt: Date;

    updatedAt?: Date;

    deletedAt?: Date;

    issues: CustomerCardIssueModel[] = [];

    get idImageURL(): string {

        if (this.issues?.length) {
            // Ordenar la lista por el más reciente
            const recent = this.issues.sort((a, b) => b.id - a.id);
            return recent[0].idImageURL;
        }
        return null;
    }

    get cardImageURL(): string {

        if (this.issues?.length) {
            // Ordenar la lista por el más reciente
            const recent = this.issues.sort((a, b) => b.id - a.id);
            return recent[0].cardImageURL;
        }
        return null;
    }

    get verifiedAt(): Date {

        if (this.issues?.length) {
            // Ordenar la lista por el más reciente
            const recent = this.issues.sort((a, b) => b.id - a.id);
            return recent[0].verifiedAt;
        }
        return null;
    }

    get rejectedAt(): Date {

        if (this.issues?.length) {
            // Ordenar la lista por el más reciente
            const recent = this.issues.sort((a, b) => b.id - a.id);
            return recent[0].rejectedAt;
        }
        return null;
    }


    get logoURL(): string {

        switch (this.brand?.toLocaleLowerCase()) {
            case 'amex':
                return 'assets/images/card-amex.png';
            case 'mastercard':
                return 'assets/images/card-master.png';
            case 'visa':
                return 'assets/images/card-visa.png';
        }
    }
}


export class CustomerCardIssueModel {

    public constructor(init?: Partial<Pick<CustomerCardIssueModel, keyof CustomerCardIssueModel>>) {

        if (init) {
            if (typeof init.verifiedAt === 'string') {
                init.verifiedAt = new Date(init.verifiedAt);
            }
            if (typeof init.rejectedAt === 'string') {
                init.rejectedAt = new Date(init.rejectedAt);
            }
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;

    token: string;

    customerId: number;


    type: CardIssueType;

    description: string;

    status: CardIssueStatus;

    notes: string;


    idImageURL: string;

    cardImageURL: string;

    verifiedAt?: Date;

    rejectedAt?: Date;


    createdAt: Date;

    updatedAt?: Date;
}